import { adminRequester } from "App";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { style } from "components/buttons/AdminCustomButton";
import NiceModal from "@ebay/nice-modal-react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import _ from "lodash";
/* 
  header format
  {
    code: data's key
    attr: attribute's name
  }
*/
const readExcelFile = (file, header) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      // const processedData = jsonData.map((row) => ({
      //   id: row["작성일자"],
      //   quantity: row["공급자 성명"],
      // }));
      const processedData = jsonData.map((row) => {
        const data = header?.reduce((acc, head) => {
          acc[head?.attr] = row[head?.code];
          return acc;
        }, {});
        return data;
      });

      resolve(processedData);
    };

    reader.onerror = reject;

    reader.readAsBinaryString(file);
  });
};
const downloadExcelFile = async (
  list = [],
  fileName = undefined,
  empty = [],
  header = [],
  style = {},
  onSuccess = () => {}
) => {
  const pattern = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
  const _ = require("lodash");
  const calcWidth = (text) =>
    ([...`${text}`]?.reduce(
      (pre, acc) => pre + (pattern.test(acc) ? 17.5 : 10),
      0
    ) +
      11) /
      1.15 || 0;
  let array = [];
  let wpx = header.map((headerCol) => ({ wpx: calcWidth(headerCol.text) }));

  list.forEach((row, index) => {
    let obj = {};
    header.forEach((headerCol, ColIndex) => {
      let value;
      if (headerCol.Cell) {
        value = headerCol.Cell({
          row: row,
          cell: row[headerCol.code],
          index: index,
        });
      } else {
        value = row[headerCol.code] !== undefined ? row[headerCol.code] : "";
      }
      obj[headerCol.text] = {
        v: value,
        s: _.merge(
          {},
          style?.common,
          style?.col,
          headerCol?.style?.common,
          headerCol?.style?.col
        ),
      };
      wpx[ColIndex] = {
        wpx: Math.max(wpx?.[ColIndex]?.wpx || 0, calcWidth(value)),
      };
    });
    array.push(obj);
  });
  const head = {};
  header.forEach(
    (headerCol) =>
      (head[headerCol.text] = {
        v: headerCol.text,
        s: _.merge(
          {},
          style?.common,
          style?.header,
          headerCol?.style?.common,
          headerCol?.style?.header
        ),
      })
  );
  const worksheet = XLSX.utils.json_to_sheet([...empty, head, ...array], {
    skipHeader: true,
  });
  // 너비 적용
  worksheet["!cols"] = wpx;
  // 헤더 스타일 적용
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  // XLSXStyle.apply_style(workbook, worksheet);
  const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });

  // 이진 데이터를 Blob으로 변환하는 함수입니다.
  function s2ab(s) {
    const buffer = new ArrayBuffer(s.length);
    const view = new Uint8Array(buffer);
    for (let i = 0; i < s.length; i++) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buffer;
  }

  // Blob을 이용하여 사용자가 파일을 다운로드 할 수 있게 합니다.
  saveAs(
    new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
    `${fileName}.xlsx`
  );

  if (onSuccess.constructor.name === "Function") onSuccess?.(list);
  else await onSuccess?.(list);
};

const TableButton = (code, onSuccess, props) => {
  const limitCheck = (indexes, min, max = indexes.length) => {
    if (indexes.length < min) {
      toast.error(`최소 ${min}가지 이상을 선택해야합니다.`, {
        autoClose: 1000,
        position: "bottom-center",
      });
      return false;
    }
    if (indexes.length > max) {
      toast.error(`최대 ${max}가지 이하를 선택해야합니다.`, {
        autoClose: 1000,
        position: "bottom-center",
      });
      return false;
    }
    return true;
  };
  const default_Process = async (data, indexes, process) => {
    if (limitCheck(indexes, 1)) {
      const r = await Promise.all(
        await indexes?.map(async (index) => await process(data[index]))
      );
      onSuccess?.(r);
    }
  };
  const getList = (data, indexes) => {
    return indexes?.map((index) => data[index]);
  };
  return {
    capture: {
      label: "입금확인",
      style: style.blue,
      onClick: async (data, indexes) =>
        await default_Process(data, indexes, async (order) => {
          await adminRequester.updateOrderStatus(order.id, {
            payment_status: "captured",
          });

          await adminRequester.updateCustomer(order.customer.id, {
            metadata: _.merge(order.customer.metadata || {}, {
              amount: Math.max(
                0,
                (Number(order.customer.metadata?.amount) || 0) -
                  (Number(order.payments?.[0]?.amount) || 0)
              ),
            }),
          });
        }),
    },
    reset_moeny: {
      label: "입금액 초기화",
      style: style.blue,
      onClick: async (data, indexes) =>
        await default_Process(
          data,
          indexes,
          async (order) =>
            await adminRequester.updateCustomer(order.customer.id, {
              metadata: _.merge(order.customer.metadata || {}, { amount: 0 }),
            })
        ),
    },
    customer_reset_moeny: {
      label: "입금액 초기화",
      style: style.white_border,
      onClick: async (data, indexes) =>
        await default_Process(
          data,
          indexes,
          async (customer) =>
            await adminRequester.updateCustomer(customer.id, {
              metadata: _.merge(customer.metadata || {}, { amount: 0 }),
            })
        ),
    },
    order_cancel: {
      label: "취소 신청",
      style: style.blue,
      onClick: async (data, indexes) =>
        await default_Process(data, indexes, async (order) => {
          return await adminRequester.updateOrderStatus(order.id, {
            status: "canceled",
            payment_status: "awaiting",
            fulfillment_status: "canceled",
            canceled_at: new Date(),
          });
        }),
    },
    allowOrderCancel: {
      label: "취소 승인",
      style: style.blue,
      onClick: async (data, indexes) =>
        await default_Process(
          data,
          indexes,
          async (order) =>
            await adminRequester.updateOrderStatus(order.id, {
              status: "canceled",
              payment_status: "canceled",
              fulfillment_status: "canceled",
            })
        ),
    },
    ship_ready: {
      label: "배송대기 처리",
      style: style.blue,
      onClick: async (data, indexes) =>
        await default_Process(data, indexes, async (order) =>
          order.fulfillments?.length > 0
            ? await adminRequester.updateOrderStatus(order.id, {
                fulfillment_status: "fulfilled",
              })
            : await adminRequester.createFulfillment(
                order.id,
                {
                  items:
                    order?.items.map((item) => ({
                      item_id: item.id,
                      quantity: item.quantity,
                    })) || [],
                },
                async () =>
                  await adminRequester.updateOrderStatus(order.id, {
                    fulfillment_status: "fulfilled",
                  })
              )
        ),
    },
    shipping: {
      label: "배송중 처리",
      style: style.blue,
      onClick: async (data, indexes) =>
        await default_Process(
          data,
          indexes,
          async (order) =>
            await adminRequester.updateOrderStatus(order.id, {
              status: "pending",
              fulfillment_status: "partially_shipped",
            })
        ),
    },
    product_ready: {
      label: "상품 준비중 처리",
      style: style.blue,
      onClick: async (data, indexes) =>
        await default_Process(
          data,
          indexes,
          async (order) =>
            await adminRequester.updateOrderStatus(order.id, {
              fulfillment_status: "not_fulfilled",
            })
        ),
    },
    ship_complete: {
      label: "배송완료 처리",
      style: style.blue,
      onClick: async (data, indexes) =>
        await default_Process(
          data,
          indexes,
          async (order) =>
            await adminRequester.updateOrderStatus(order.id, {
              status: "completed",
              fulfillment_status: "shipped",
              fulfillment_id:
                order?.fulfillments?.[order?.fulfillments?.length - 1]?.id,
            })
        ),
    },
    canceledOrderCancel: {
      label: "취소 철회",
      style: style.blue,
      onClick: async (data, indexes) =>
        await default_Process(
          data,
          indexes,
          async (order) =>
            await adminRequester.updateOrderStatus(order.id, {
              status: "pending",
              payment_status: "awaiting",
              fulfillment_status: "not_fulfilled",
              canceled_at: null,
            })
        ),
    },
    exchange: {
      label: "교환 신청",
      style: style.blue,
      onClick: async (data, indexes) =>
        await default_Process(
          data,
          indexes,
          async (order) =>
            await adminRequester.updateOrderStatus(order.id, {
              status: "exchange",
              fulfillment_status: "not_fulfilled",
              fulfillment_id:
                order?.fulfillments?.[order?.fulfillments?.length - 1]?.id,
            })
        ),
    },
    canceledExchange: {
      label: "교환 철회",
      style: style.blue,
      onClick: async (data, indexes) =>
        await default_Process(
          data,
          indexes,
          async (order) =>
            await adminRequester.updateOrderStatus(order.id, {
              status: "completed",
              fulfillment_status: "shipped",
            })
        ),
    },
    refund: {
      label: "환불 신청",
      style: style.blue,
      onClick: async (data, indexes) =>
        await default_Process(
          data,
          indexes,
          async (order) =>
            await adminRequester.updateOrderStatus(order.id, {
              status: "refund",
              payment_status: "awaiting",
              fulfillment_status: "not_fulfilled",
              payment_id: order?.payments?.[order?.payments?.length - 1]?.id,
            })
        ),
    },
    canceledRefund: {
      label: "환불 철회",
      style: style.blue,
      onClick: async (data, indexes) =>
        await default_Process(
          data,
          indexes,
          async (order) =>
            await adminRequester.updateOrderStatus(order.id, {
              status: "completed",
              fulfillment_status: "shipped",
            })
        ),
    },
    return: {
      label: "수거완료",
      style: style.blue,
      onClick: async (data, indexes) =>
        await default_Process(data, indexes, async (order) => {
          if (order.status === "exchange") {
            // if (order.fulfillment_status === "not_fulfilled") {
            //   await adminRequester.updateOrderStatus(order.id, {
            //     fulfillment_status: "returned",
            //   });
            // } else if (order.fulfillment_status === "partially_returned") {
            // await adminRequester.updateOrderStatus(order.id, {
            //   fulfillment_status: "shipped",
            // });
            // }
            await adminRequester.updateOrderStatus(order.id, {
              fulfillment_status: "shipped",
            });
          } else if (order.status === "refund") {
            await adminRequester.updateOrderStatus(order.id, {
              payment_status: "captured",
              fulfillment_status: "shipped",
            });
          }
          return;
        }),
    },
    productRegist: {
      label: "상품 등록",
      style: style.blue,
      onClick: () => onSuccess?.(),
    },
    mainDisplay: {
      label: "메인진열관리",
      style: style.white,
      onClick: () => onSuccess?.(),
    },
    productDisplay: {
      label: "진열",
      style: style.white,
      onClick: async (data, indexes) =>
        await default_Process(
          data,
          indexes,
          async (product) =>
            await adminRequester.updateProduct(product.id, {
              status: "published",
            })
        ),
    },
    productUndisplay: {
      label: "미진열",
      style: style.white,
      onClick: async (data, indexes) =>
        await default_Process(
          data,
          indexes,
          async (product) =>
            await adminRequester.updateProduct(product.id, {
              status: "rejected",
            })
        ),
    },
    productNotSold: {
      label: "판매",
      style: style.white,
      onClick: async (data, indexes) =>
        await default_Process(
          data,
          indexes,
          async (product) =>
            await adminRequester.updateProduct(product.id, {
              buyable: product?.variants?.length > 0,
            })
        ),
    },
    productSold: {
      label: "판매중지",
      style: style.white,
      onClick: async (data, indexes) =>
        await default_Process(
          data,
          indexes,
          async (product) =>
            await adminRequester.updateProduct(product.id, {
              buyable: false,
            })
        ),
    },
    productCopy: {
      label: "복사",
      style: style.white,
      onClick: async (data, indexes) =>
        await default_Process(data, indexes, async (product) => {
          const copy = {};
          copy.thumbnail = product.thumbnail;
          copy.title = product.title;
          copy.handle = `${new Date().getTime()}_${copy.title}`;
          copy.description = product.description;
          copy.status = product.status;
          copy.categories = product.categories?.map((category) => ({
            id: category.id,
          }));
          copy.store_id = product.store_id;
          copy.price = product.price;
          // copy.customer_price =
          copy.buyable = product.buyable;
          copy.content = product.content;
          const options = product.options;
          const variants = product.variants;
          return await adminRequester.postProduct(
            { ...copy },
            async (result) => {
              const { product } = result;
              return await Promise.all(
                options.map(async (op) => {
                  return adminRequester.postProductOption(
                    product?.id,
                    { title: op.title },
                    () => {}
                  );
                })
              ).then(async () => {
                return adminRequester.getProduct(
                  product?.id,
                  { expand: "options" },
                  async (result) => {
                    const { product } = result;

                    return await Promise.all(
                      variants?.map(async (variant) => {
                        const copy = {};
                        copy.thumbnail = variant.thumbnail;
                        copy.title = variant.title;
                        copy.inventory_quantity = variant.inventory_quantity;
                        copy.check = variant.check;
                        copy.sold = variant.sold;
                        copy.options = variant.options
                          .map((option) => {
                            const find = product?.options?.filter(
                              (f) => f.title === option.option.title
                            );

                            return find?.length > 0
                              ? {
                                  option_id: find[0]?.id,
                                  value: option.value,
                                }
                              : null;
                          })
                          .filter((op) => !!op);
                        const prices = [
                          { amount: variant.price, currency_code: "krw" },
                        ];
                        return await adminRequester.postVariants(
                          product.id,
                          copy,
                          async (result) =>
                            adminRequester.updateVariant(
                              product.id,
                              result.variant.id,
                              { prices: prices }
                            )
                        );
                      })
                    );
                  }
                );
              });
            }
          );
        }),
    },
    productDelete: {
      label: "삭제",
      style: style.white,
      onClick: async (data, indexes) =>
        await default_Process(
          data,
          indexes,
          async (product) => await adminRequester.deleteProduct(product.id)
        ),
    },
    productCategory: {
      label: "분류수정",
      style: style.white,
      onClick: async (data, indexes) =>
        limitCheck(indexes, 1) &&
        NiceModal.show("categoryEdit", {
          data: getList(data, indexes),
          onSuccess: onSuccess,
        }),
    },
    stockAll: {
      label: "재고관리 일괄설정",
      style: style.white_border,
      onClick: async (data, indexes) =>
        limitCheck(indexes, 1) &&
        NiceModal.show("confirmSelect", {
          data: getList(data, indexes),
          message: `선택한 ${indexes?.length}개의 관리 설정을 일괄 수정합니다.`,
          buttons: [
            {
              text: "취소",
              style: style.white,
            },
            {
              text: "미사용",
              onClick: (data) => {
                Promise.all(
                  data?.map(async (variant) =>
                    adminRequester.updateVariant(
                      variant.product.id,
                      variant.id,
                      { manage_inventory: false }
                    )
                  )
                ).then(() => onSuccess());
              },
              style: style.white,
            },
            {
              text: "사용",
              onClick: (data) => {
                Promise.all(
                  data?.map(async (variant) =>
                    adminRequester.updateVariant(
                      variant.product.id,
                      variant.id,
                      { manage_inventory: true }
                    )
                  )
                ).then(() => onSuccess());
              },
              style: style.white,
            },
          ],
        }),
    },
    excelUpload: {
      label: props?.label || "업로드",
      type: "file",
      style: style.white_border,
      onChange: async (file, data, indexes) => {
        const uploadFile = file.files[0];
        switch (uploadFile.type) {
          case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          case "text/csv": {
            const list = await readExcelFile(
              uploadFile,
              (Array.isArray(props.header) ? props.header : [props.header]) ||
                []
            );
            onSuccess(list);
            toast.success("정보가 성공적으로 업데이트되었습니다.", {
              autoClose: 1000,
              position: toast.POSITION.BOTTOM_CENTER,
            });
            break;
          }
          default: {
            toast.error(`${uploadFile.type}은 형식에 맞지 않는 데이터입니다.`, {
              autoClose: 1000,
              position: toast.POSITION.BOTTOM_CENTER,
            });
            break;
          }
        }

        file.value = "";
      },
    },
    empty: {
      label: "",
      style: { ...style.none, hidden: true, marginLeft: "auto" },
    },
    excelDownload: {
      label: props?.label || "엑셀 다운로드",
      style: style.white_border,
      onClick: async (data, indexes) => {
        let list;
        if (indexes.length === 0) {
          if (!props?.onReload) {
            toast.error(`최소 1가지 이상을 선택해야합니다.`, {
              autoClose: 1000,
              position: "bottom-center",
            });
            return;
          } else {
            list = await props.onReload();
          }
        } else list = getList(data, indexes);

        downloadExcelFile(
          list,
          `${props?.fileName}_${new Date().getTime()}`,
          props.empty,
          props?.header,
          props?.style,
          () => {
            props?.onSuccess?.();
            onSuccess?.();
          }
        );
      },
    },
    customerActive: {
      label: "계정 활성화",
      style: style.white_border,
      onClick: async (data, indexes) =>
        default_Process(data, indexes, (customer) =>
          adminRequester.updateCustomer(customer?.id, { has_account: true })
        ),
    },
    customerInactive: {
      label: "계정 비활성화",
      style: style.white_border,
      onClick: async (data, indexes) =>
        default_Process(data, indexes, (customer) =>
          adminRequester.updateCustomer(customer?.id, { has_account: false })
        ),
    },
    customerDelete: {
      label: "계정 탈퇴",
      style: style.white_border,
      onClick: async (data, indexes) =>
        default_Process(data, indexes, (customer) =>
          adminRequester.updateCustomer(customer?.id, {
            deleted_at: new Date(),
          })
        ),
    },
    customerRevive: {
      label: "계정 복구",
      style: style.white_border,
      onClick: async (data, indexes) =>
        default_Process(data, indexes, (customer) =>
          adminRequester.updateCustomer(customer?.id, {
            deleted_at: null,
          })
        ),
    },
    restoreAccount: {
      label: "계좌 재할당",
      style: style.white_border,
      onClick: async (data, indexes) =>
        default_Process(data, indexes, (customer) =>
          adminRequester.updateCustomer(customer?.id, {
            has_account: true,
          })
        ),
    },
    resetPassword: {
      label: "비밀번호 초기화",
      style: style.white_border,
      onClick: async (data, indexes) =>
        NiceModal.show("confirm", {
          message: "정말 초기화하시겠습니까?",
          confirmText: "네",
          cancelText: "아니요",
          onConfirm: () =>
            default_Process(data, indexes, (customer) =>
              adminRequester.updateCustomer(customer?.id, {
                resetPassword: true,
                password_hash:
                  "c2NyeXB0AAEAAAABAAAAAeQDR7wSR4/kee1YISYuTUlVM6CX5QMlevNYu262wdYdEyyhvjjQKFkgBcuAoGeRL4IgRelmV2tvFpfMSFUnYd9GZel8LfK7+IQZwPdp7aby",
              })
            ),
        }),
    },
    articleDelete: {
      label: "게시글 삭제",
      style: style.white_border,
      onClick: async (data, indexes) =>
        default_Process(data, indexes, (article) =>
          adminRequester.updateArticle(article?.id, {
            deleted_at: new Date(),
          })
        ),
    },
  }[code];
};
export default TableButton;
